import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {DocumentSourceTypeEnum} from 'nutshell-graphql-types';
import type {
    GetContextDocuments as GetContextDocumentsQuery,
    GetContextDocumentsVariables as GetContextDocumentsQueryVariables,
} from 'nutshell-graphql-types';

import {usePoll} from '../../../../../util/hooks/use-poll';

import GET_CONTEXT_DOCUMENTS from '../queries/get-context-documents.graphql';

const POLL_INTERVAL_MILLISECONDS = 5000; // 5 seconds

export const useGetContextDocuments = (
    includeExcluded: boolean,
    sourceType?: DocumentSourceTypeEnum,
    onPollingComplete?: () => Promise<any> | undefined
) => {
    const {data, loading, error, refetch, startPolling, stopPolling} = useQuery<
        GetContextDocumentsQuery,
        GetContextDocumentsQueryVariables
    >(GET_CONTEXT_DOCUMENTS, {
        variables: {
            includeExcluded,
            sourceType,
        },
        fetchPolicy: 'cache-and-network',
    });

    const contextDocuments = data ? data.contextDocuments : [];
    const primaryContextDocument = data ? data.primaryContextDocument : null;

    const shouldPoll = contextDocuments.some(
        (document) => document && document.effectiveStatus === 'PENDING'
    );

    usePoll({
        shouldPoll,
        startPolling,
        stopPolling,
        interval: POLL_INTERVAL_MILLISECONDS,
        onPollComplete: onPollingComplete,
    });

    return {
        contextDocuments,
        primaryContextDocument,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        isLoading: loading,
        refetch,
    };
};
